import $ from "jquery";

export const init = () => {
  let debounce = (func, timeout = 300) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  };

  let processInput = (e) => {
    if (e.target.value.length < 3) {
      $(".ctype-ce_themen_von_a_bis_z .hide").removeClass("hide");
      return;
    }

    $(".themen-link").each(function () {
      let $this = $(this);
      let text = $this.text();
      let re = new RegExp(e.target.value, "i");
      let position = text.search(re);

      if (position === -1) $this.parents("li").addClass("hide");
    });

    $(".ctype-ce_themen_von_a_bis_z ul").each(function () {
      let $this = $(this);
      let liEl = $this.find("li").length;
      let liElHi = $this.find("li.hide").length;

      if (liEl === liElHi) $this.parents(".hideable").addClass("hide");
    });
  };

  let processChange = debounce((e) => processInput(e));

  $(".ctype-ce_themen_von_a_bis_z .search-box input").on(
    "keyup",
    processChange
  );

  $(".ctype-ce_themen_von_a_bis_z .search-box .btn").on("click", function () {
    $(".ctype-ce_themen_von_a_bis_z .search-box input").val("");
    $(".ctype-ce_themen_von_a_bis_z .hide").removeClass("hide");
  });
};
